var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCustomHeaders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7891 10.32L20.3164 7.84725C20.0933 7.62489 19.7913 7.50002 19.4764 7.50002C19.1614 7.50002 18.8594 7.62489 18.6364 7.84725L8.13635 18.3505V22.5H12.2858L22.7891 12C23.0115 11.777 23.1363 11.4749 23.1363 11.16C23.1363 10.8451 23.0115 10.543 22.7891 10.32ZM11.6645 21H9.63635V18.9718L16.717 11.8912L18.7452 13.9193L11.6645 21ZM19.8057 12.8588L17.7776 10.8307L19.478 9.13028L21.5062 11.1584L19.8057 12.8588Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88635 12.75H10.3864V7.5H12.6364V6H6.63635V7.5H8.88635V12.75Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63635 15H3.63635V3H15.6364V6H17.1364V3C17.1364 2.60218 16.9783 2.22064 16.697 1.93934C16.4157 1.65804 16.0342 1.5 15.6364 1.5H3.63635C3.23853 1.5 2.857 1.65804 2.57569 1.93934C2.29439 2.22064 2.13635 2.60218 2.13635 3V15C2.13635 15.3978 2.29439 15.7794 2.57569 16.0607C2.857 16.342 3.23853 16.5 3.63635 16.5H6.63635V15Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCustomHeaders);
export default __webpack_public_path__ + "static/media/ic-custom-headers.029f9d0ee908a799448b60f54b0f6679.svg";
export { ForwardRef as ReactComponent };